document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("olive-oil-selector");
  if (!root || root.getAttribute("data-olive-oil-selector-init") === "1") {
    return;
  }
  root.setAttribute("data-olive-oil-selector-init", "1");

  const productDataEl = document.getElementById("true-product-data");
  if (!productDataEl) {
    return;
  }

  let product;
  try {
    product = JSON.parse(productDataEl.textContent);
  } catch (e) {
    return;
  }

  if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
    return;
  }

  const servings = productDataEl.getAttribute("data-serving") || "";
  const icon = productDataEl.getAttribute("data-icon") || "";
  const sellingPlanGroups = product.selling_plan_groups || [];

  const quantityInput = root.querySelector("#sampler-quantity");
  if (!quantityInput) {
    return;
  }

  const minQuantity = 1;

  function findVariantById(id) {
    const sid = String(id);
    return product.variants.find((v) => String(v.id) === sid) || product.variants[0];
  }

  let selectedVariant = findVariantById(
    root.querySelector(".olive-variant-option--selected")?.getAttribute("data-variant-id") ||
      product.selected_or_first_available_variant?.id ||
      product.variants[0].id
  );

  function moneyFieldToCents(raw, referenceCents) {
    if (raw == null || raw === "") return null;
    if (typeof raw === "number" && Number.isFinite(raw)) {
      if (raw === Math.floor(raw) && raw >= 100) {
        return Math.round(raw);
      }
      return Math.round(raw * 100);
    }
    const n = parseFloat(String(raw).replace(/[^0-9.-]/g, ""));
    if (!Number.isFinite(n)) return null;
    return Math.round(n * 100);
  }

  function allocationSellingPlanId(a) {
    return (
      a.selling_plan_id ??
      a.selling_plan?.id ??
      a.selling_plan?.selling_plan_id ??
      null
    );
  }

  function subscriptionUnitCents(variant, sellingPlanId) {
    if (!variant || !sellingPlanId) return null;
    const idStr = String(sellingPlanId).replace(/^["']|["']$/g, "").trim();
    const allocations = variant.selling_plan_allocations || [];
    const alloc = allocations.find((a) => {
      const sid = allocationSellingPlanId(a);
      return sid != null && String(sid) === idStr;
    });
    if (!alloc) return null;
    const raw = alloc.per_delivery_price ?? alloc.price;
    const cents = moneyFieldToCents(raw, variant.price);
    return cents != null ? cents : null;
  }

  const QuantitySelector = {
    elements: {
      input: quantityInput,
      decreaseBtn: root.querySelector(".quantity-decrease"),
      increaseBtn: root.querySelector(".quantity-increase"),
    },

    init() {
      this.syncDataQtyFromValue();
      this.attachEventListeners();
    },

    syncDataQtyFromValue() {
      const v = parseInt(this.elements.input.value, 10) || minQuantity;
      this.elements.input.setAttribute("data-qty", String(v));
      this.elements.input.value = String(v);
    },

    attachEventListeners() {
      if (this.elements.decreaseBtn) {
        this.elements.decreaseBtn.addEventListener("click", () => {
          let currentValue =
            parseInt(this.elements.input.getAttribute("data-qty"), 10) ||
            parseInt(this.elements.input.value, 10) ||
            minQuantity;
          if (currentValue > minQuantity) {
            currentValue -= 1;
            this.elements.input.setAttribute("data-qty", String(currentValue));
            this.elements.input.value = String(currentValue);
            this.onQuantityChange();
          }
        });
      }
      if (this.elements.increaseBtn) {
        this.elements.increaseBtn.addEventListener("click", () => {
          let currentValue =
            parseInt(this.elements.input.getAttribute("data-qty"), 10) ||
            parseInt(this.elements.input.value, 10) ||
            minQuantity;
          if (currentValue < 99) {
            currentValue += 1;
            this.elements.input.setAttribute("data-qty", String(currentValue));
            this.elements.input.value = String(currentValue);
            this.onQuantityChange();
          }
        });
      }
      if (this.elements.input) {
        this.elements.input.addEventListener("input", () => this.onQuantityChange());
      }
    },

    onQuantityChange() {
      let v =
        parseInt(this.elements.input.getAttribute("data-qty"), 10) ||
        parseInt(this.elements.input.value, 10);
      if (!Number.isFinite(v) || v < minQuantity) v = minQuantity;
      if (v > 99) v = 99;
      this.elements.input.setAttribute("data-qty", String(v));
      this.elements.input.value = String(v);
      if (typeof PriceUpdater !== "undefined") {
        PriceUpdater.update();
      }
    },

    getValue() {
      const fromAttr = parseInt(this.elements.input.getAttribute("data-qty"), 10);
      if (Number.isFinite(fromAttr) && fromAttr >= minQuantity) {
        return fromAttr;
      }
      return parseInt(this.elements.input.value, 10) || minQuantity;
    },
  };

  const PriceUpdater = {
    elements: {
      onetimeRadio: document.getElementById("new-bundle-atc-onetime"),
      subscriptionRadio: document.getElementById("new-bundle-atc-subscription"),
      sellingPlanSelect: document.getElementById("new-bundle-selling_plan_select"),
      onetimePrice: document.getElementById("onetime-price"),
      subscriptionPrice: document.getElementById("subscription-price"),
      subscriptionCompareat: document.getElementById("subscription-compareat"),
    },

    init() {
      this.attachEventListeners();
      this.updateFrequencySelectorVisibility();
      this.updateSubscriptionAvailability();
      this.update();
    },

    syncSubscriptionLabelAria() {
      const subscriptionLabel = root.querySelector(".subscribe-select .bundle-subscription-label");
      if (subscriptionLabel && this.elements.subscriptionRadio) {
        subscriptionLabel.setAttribute(
          "aria-checked",
          this.elements.subscriptionRadio.checked ? "true" : "false"
        );
      }
    },

    attachEventListeners() {
      if (this.elements.onetimeRadio) {
        this.elements.onetimeRadio.addEventListener("change", () => {
          if (this.elements.onetimeRadio.checked) {
            this.updateFrequencySelectorVisibility();
            this.update();
            this.syncSubscriptionLabelAria();
          }
        });
      }
      if (this.elements.subscriptionRadio) {
        this.elements.subscriptionRadio.addEventListener("change", () => {
          this.syncSubscriptionLabelAria();
          if (this.elements.subscriptionRadio.checked) {
            this.updateFrequencySelectorVisibility();
            this.update();
            if (this.elements.sellingPlanSelect) {
              requestAnimationFrame(() => this.elements.sellingPlanSelect.focus());
            }
          }
        });
      }

      const subscriptionLabel = root.querySelector(".subscribe-select .bundle-subscription-label");
      if (subscriptionLabel) {
        subscriptionLabel.addEventListener("keydown", (e) => {
          if (e.key !== "Enter" && e.key !== " ") return;
          e.preventDefault();
          if (subscriptionLabel.getAttribute("aria-disabled") === "true") return;
          const radio = subscriptionLabel.querySelector('input[type="radio"]');
          if (radio && !radio.disabled) {
            radio.click();
            const sellingPlanSelect = document.getElementById("new-bundle-selling_plan_select");
            if (sellingPlanSelect) {
              requestAnimationFrame(() => sellingPlanSelect.focus());
            }
          }
        });
      }

      if (this.elements.sellingPlanSelect) {
        this.elements.sellingPlanSelect.addEventListener("change", () => this.update());
      }
    },

    lineTotals(variant, quantity) {
      const unitOnetime = variant.price || 0;
      const oneTimePrice = unitOnetime * quantity;

      const planId = this.elements.sellingPlanSelect?.value;
      let unitSub = subscriptionUnitCents(variant, planId);
      if (unitSub == null) {
        unitSub = Math.round(unitOnetime * 0.9);
      }
      const subscriptionPrice = unitSub * quantity;

      return { oneTimePrice, subscriptionPrice, unitOnetime, unitSub };
    },

    formatMoney(cents) {
      return "$" + Math.round(cents / 100);
    },

    formatMoneySubscription(cents) {
      const dollars = (cents / 100).toFixed(2);
      return "$" + dollars.replace(/\.00$/, "");
    },

    formatMoneyDetailed(cents) {
      const dollars = (cents / 100).toFixed(2);
      return "$" + dollars.replace(/\.00$/, "");
    },

    updateActualAtcBar() {
      const bar = document.querySelector(".inline-atc .actual-atc");
      if (!bar) return;
      if (bar.getAttribute("data-sold-out") === "true") {
        bar.textContent = "Sold Out";
        return;
      }

      const variant = selectedVariant;
      const quantity = QuantitySelector.getValue();
      const hasPlans =
        this.elements.sellingPlanSelect &&
        this.elements.subscriptionRadio &&
        !this.elements.subscriptionRadio.disabled;
      const isSub =
        this.elements.subscriptionRadio &&
        this.elements.subscriptionRadio.checked &&
        hasPlans;
      const { oneTimePrice, subscriptionPrice } = this.lineTotals(variant, quantity);

      const handle =
        productDataEl.getAttribute("data-product-handle") || product.handle || "";
      const boxesPerUnit =
        handle === "olive-oil-bundle" || handle === "gratsi-oil-variety-pack" ? 2 : 1;
      const boxCount = quantity * boxesPerUnit;
      const boxLabel = boxCount === 1 ? "Box" : "Boxes";
      let html =
        (isSub ? "Subscribe" : "Add to Cart") +
        " (" +
        boxCount +
        " " +
        boxLabel +
        ") •&nbsp;";
      if (isSub) {
        html +=
          '<span class="strike">' + this.formatMoneyDetailed(oneTimePrice) + "</span> ";
        html += this.formatMoneySubscription(subscriptionPrice);
      } else {
        const cu = variant.compare_at_price;
        if (cu && cu > variant.price) {
          html +=
            '<span class="strike">' + this.formatMoneyDetailed(cu * quantity) + "</span> ";
        }
        html += this.formatMoneyDetailed(oneTimePrice);
      }
      bar.innerHTML = html;
    },

    update() {
      const variant = selectedVariant;
      const quantity = QuantitySelector.getValue();
      const { oneTimePrice, subscriptionPrice } = this.lineTotals(variant, quantity);
      const formattedOneTime = this.formatMoney(oneTimePrice);
      const formattedSub = this.formatMoneySubscription(subscriptionPrice);

      if (this.elements.onetimePrice) {
        this.elements.onetimePrice.textContent = formattedOneTime;
      }

      const hasPlans =
        this.elements.sellingPlanSelect && this.elements.subscriptionRadio && !this.elements.subscriptionRadio.disabled;

      if (hasPlans) {
        if (this.elements.subscriptionCompareat) {
          this.elements.subscriptionCompareat.innerHTML =
            '<span aria-hidden="true">' + formattedOneTime + "</span>";
          this.elements.subscriptionCompareat.setAttribute("aria-label", "Previous price " + formattedOneTime);
          this.elements.subscriptionCompareat.style.display = "inline";
        }
        if (this.elements.subscriptionPrice) {
          this.elements.subscriptionPrice.textContent = formattedSub;
          this.elements.subscriptionPrice.style.fontStyle = "normal";
          this.elements.subscriptionPrice.style.color = "#212322";
          this.elements.subscriptionPrice.classList.remove("nav-link");
          this.elements.subscriptionPrice.style.margin = "";
        }
      } else {
        if (this.elements.subscriptionCompareat) {
          this.elements.subscriptionCompareat.style.display = "none";
          this.elements.subscriptionCompareat.removeAttribute("aria-label");
        }
        if (this.elements.subscriptionPrice) {
          this.elements.subscriptionPrice.textContent = "";
        }
      }

      const isSub = this.elements.subscriptionRadio && this.elements.subscriptionRadio.checked && hasPlans;

      this.syncStickyDisplay(variant, quantity, isSub ? subscriptionPrice : oneTimePrice, isSub);
      this.syncLegacyAtcAttributes(variant);
      this.updateActualAtcBar();
    },

    syncStickyDisplay(variant, quantity, lineCents, isSubscription) {
      const stickyPrice = document.querySelector("#sticky-cta .price");
      if (!stickyPrice) return;

      const formatLine = isSubscription ? this.formatMoneySubscription.bind(this) : this.formatMoney.bind(this);
      const compareAt = variant.compare_at_price;
      const unit = variant.price;
      let html = "";
      if (compareAt && compareAt > unit) {
        const compareLine = compareAt * quantity;
        html +=
          '<span class="strike">' + this.formatMoney(compareLine) + "</span> ";
      }
      html += formatLine(lineCents);
      stickyPrice.innerHTML = html;
    },

    syncLegacyAtcAttributes(variant) {
      const legacy = document.querySelector(".inline-atc .actual-atc");
      if (!legacy) return;
      legacy.setAttribute("data-variant", String(variant.id));
      legacy.setAttribute("data-base-price", String(variant.price));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        legacy.setAttribute("data-compare-price", String(variant.compare_at_price));
      } else {
        legacy.removeAttribute("data-compare-price");
      }
    },

    updateSubscriptionAvailability() {
      const subscribeRow = root.querySelector(".subscribe-select");
      const subscriptionLabel = root.querySelector(".subscribe-select .bundle-subscription-label");
      const hasSelect = !!this.elements.sellingPlanSelect;

      if (!subscribeRow) return;

      if (!hasSelect) {
        if (subscriptionLabel) {
          subscriptionLabel.classList.add("disabled");
          subscriptionLabel.setAttribute("tabindex", "0");
          subscriptionLabel.setAttribute("aria-disabled", "true");
        }
        if (this.elements.subscriptionRadio) {
          this.elements.subscriptionRadio.disabled = true;
          this.elements.subscriptionRadio.setAttribute("tabindex", "-1");
        }
        if (this.elements.onetimeRadio) {
          this.elements.onetimeRadio.checked = true;
        }
        this.updateFrequencySelectorVisibility();
        this.syncSubscriptionLabelAria();
        return;
      }

      if (subscriptionLabel) {
        subscriptionLabel.classList.remove("disabled");
        subscriptionLabel.setAttribute("tabindex", "0");
        subscriptionLabel.removeAttribute("aria-disabled");
      }
      if (this.elements.subscriptionRadio) {
        this.elements.subscriptionRadio.disabled = false;
        this.elements.subscriptionRadio.setAttribute("tabindex", "-1");
      }
      this.syncSubscriptionLabelAria();
    },

    updateFrequencySelectorVisibility() {
      if (!this.elements.sellingPlanSelect) return;
      const wrap = this.elements.sellingPlanSelect.closest(".bundle-selling_plan_selector");
      if (!wrap) return;
      const open =
        this.elements.subscriptionRadio &&
        this.elements.subscriptionRadio.checked &&
        !this.elements.subscriptionRadio.disabled;
      wrap.classList.toggle("bundle-selling_plan_selector--open", !!open);
    },
  };

  const AddToCart = {
    elements: {
      button: document.querySelector(".inline-atc .actual-atc"),
    },

    getBundleId(isSubscription, frequencyNumber) {
      const handle =
        productDataEl.getAttribute("data-product-handle") || product.handle || "";
      let bundleId;
      if (isSubscription && frequencyNumber != null && frequencyNumber !== "") {
        bundleId = "olive_bundle_sub_" + String(frequencyNumber);
      } else if (isSubscription) {
        bundleId = "olive_bundle_sub";
      } else {
        bundleId = "olive_bundle_onetime";
      }
      return handle ? bundleId + "_" + handle : bundleId;
    },

    init() {
      if (this.elements.button && !this.elements.button.hasAttribute("data-olive-atc-bar-bound")) {
        this.elements.button.setAttribute("data-olive-atc-bar-bound", "1");
        this.elements.button.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleAddToCart();
        });
      }

      const sticky = document.querySelector(".actual-atc-sticky");
      if (sticky && !sticky.hasAttribute("data-olive-atc-bound")) {
        sticky.setAttribute("data-olive-atc-bound", "1");
        sticky.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleAddToCart();
        });
      }
    },

    restoreButtonStructure() {
      PriceUpdater.update();
    },

    handleAddToCart() {
      const bar = this.elements.button;
      const soldOut = bar && bar.getAttribute("data-sold-out") === "true";
      if (soldOut) return;

      const cartWasEmpty =
        typeof window.isMinicartEmptyVisible === "function" && window.isMinicartEmptyVisible();

      const variant = selectedVariant;
      const quantity = QuantitySelector.getValue();
      const isSubscription =
        PriceUpdater.elements.subscriptionRadio &&
        PriceUpdater.elements.subscriptionRadio.checked &&
        !PriceUpdater.elements.subscriptionRadio.disabled;

      const sellingPlanSelect = PriceUpdater.elements.sellingPlanSelect;
      const sellingPlanId = sellingPlanSelect?.value;
      const selectedOption = sellingPlanSelect?.options[sellingPlanSelect?.selectedIndex];
      const planName =
        selectedOption?.getAttribute?.("data-plan-name") ||
        selectedOption?.dataset?.planName ||
        "";
      const frequencyNumber = planName && planName.match(/\d+/) ? planName.match(/\d+/)[0] : null;

      if (!bar) return;

      bar.style.pointerEvents = "none";
      bar.innerHTML = "Adding...";

      const sticky = document.querySelector(".actual-atc-sticky");
      if (sticky) {
        sticky.disabled = true;
        sticky.textContent = "Adding...";
      }

      if (!variant) {
        bar.style.pointerEvents = "";
        this.restoreButtonStructure();
        if (sticky) {
          sticky.disabled = false;
        }
        return;
      }

      if (isSubscription && !sellingPlanId) {
        bar.style.pointerEvents = "";
        this.restoreButtonStructure();
        if (sticky) {
          sticky.disabled = false;
        }
        window.alert("Please select a delivery frequency for your subscription.");
        return;
      }

      const variantSellingPlans = product.variants.map((v) => ({
        id: v.id,
        sellingPlans: v.selling_plan_allocations || [],
      }));

      const bundleId = this.getBundleId(isSubscription, frequencyNumber);

      const cartData = {
        items: [
          {
            id: variant.id,
            quantity: quantity,
            ...(isSubscription &&
              sellingPlanId && {
                selling_plan: sellingPlanId,
              }),
            properties: {
              _isHoliday: false,
              _bundle: bundleId,
              _bundle_icon: icon,
              _selling_plan_groups: sellingPlanGroups,
              _variant_selling_plans: variantSellingPlans,
              _serving: servings,
            },
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(errorData.description || errorData.message || "Failed to add to cart");
            });
          }
          return response.json();
        })
        .then(() => {
          if (typeof window.minicartLoadingAfterAddFromEmpty === "function") {
            window.minicartLoadingAfterAddFromEmpty(cartWasEmpty);
          }
          if (typeof cartDraw === "function") {
            cartDraw();
          }
          if (typeof openCart === "function") {
            openCart();
          }
          bar.innerHTML = "Added!";
          if (sticky) {
            sticky.textContent = "Added!";
          }
          setTimeout(() => {
            bar.style.pointerEvents = "";
            if (sticky) {
              sticky.disabled = false;
              sticky.textContent = "Add to Cart";
            }
            this.restoreButtonStructure();
          }, 2000);
        })
        .catch((error) => {
          if (typeof window.hideMinicartLoadingOverlay === "function") {
            window.hideMinicartLoadingOverlay();
          }
          window.alert(error.message || "Error adding to cart. Please try again.");
          bar.style.pointerEvents = "";
          if (sticky) {
            sticky.disabled = false;
            sticky.textContent = "Add to Cart";
          }
          this.restoreButtonStructure();
        });
    },
  };

  root.querySelectorAll(".olive-variant-option").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.disabled) return;
      root.querySelectorAll(".olive-variant-option").forEach((b) => {
        b.classList.remove("olive-variant-option--selected");
      });
      btn.classList.add("olive-variant-option--selected");

      const vid = btn.getAttribute("data-variant-id");
      selectedVariant = findVariantById(vid);

      const sticky = document.querySelector(".actual-atc-sticky");
      if (sticky) {
        sticky.setAttribute("data-variant", String(selectedVariant.id));
      }

      const idx = Array.from(root.querySelectorAll(".olive-variant-option")).indexOf(btn) + 1;
      document.querySelectorAll(".olive-variant-description").forEach((desc) => {
        desc.classList.remove("olive-variant-description--active");
        if (desc.classList.contains("olive-variant-description--" + idx)) {
          desc.classList.add("olive-variant-description--active");
        }
      });

      PriceUpdater.update();
    });
  });

  QuantitySelector.init();
  PriceUpdater.init();
  AddToCart.init();

  window.oliveUpdateVariantPrice = function () {
    PriceUpdater.update();
  };
});
